import { TermUnit } from "../../components/proposalDocuments/quotes/TermInput";

const UNIT_WORDS: Record<TermUnit, string> = {
  D: "Day",
  M: "Month",
  Y: "Year",
};

// The backend just displays the term as plaintext, so there's no need for
// the old compact "12M" encoding — store it as the human-readable string
// directly (with correct pluralisation) and parse that same format back.
export const formatTerm = (amount: string, unit: TermUnit): string => {
  const word = UNIT_WORDS[unit];
  return `${amount} ${Number(amount) === 1 ? word : `${word}s`}`;
};

const TERM_RE = /^(\d+)\s+(day|days|month|months|year|years)$/i;

export const parseTerm = (term: string): { amount: string; unit: TermUnit } => {
  const match = TERM_RE.exec(term);
  if (match) {
    return { amount: match[1], unit: match[2][0].toUpperCase() as TermUnit };
  }
  return { amount: "", unit: "Y" };
};

export const getTermFraction = (term: string | null): number => {
  if (!term) return 1; // rolling/current-supplier sections have no term — don't scale
  const match = TERM_RE.exec(term);
  if (!match) return 1; // no valid term entered yet — don't scale garbage

  const amount = Number(match[1]);
  const unit = match[2][0].toUpperCase() as TermUnit;

  if (unit === "D") return Math.min(amount / 365, 1);
  if (unit === "M") return Math.min(amount / 12, 1);
  return 1; // Y is always >= 1 year, never scaled
};
